import React from "react";
import "./Css/DigitalKarVasuli.css";
import panipurvtascnner from "./Images/PaniPuravatha Scanner.jpeg"
import gramnidhiscanner from "./Images/GramnidhiScanner.jpeg"

const DigitalKarVasuli = () => {
  return (
    <section className="digital-kar-section">
      <div className="digital-kar-container">

        {/* Title */}
        <h2 className="digital-kar-title">
          डिजिटल कर वसुली सुविधा
        </h2>

        {/* Description */}
        <p className="digital-kar-description">
          आपल्या ग्रामपंचायतीचे कर आता डिजिटल पद्धतीने भरा.
          ग्रामनिधी व पाणीपुरवठा कर भरण्यासाठी संबंधित QR Code
          स्कॅन करून सुरक्षितपणे पेमेंट करा आणि आपल्या ग्रामपंचायतीस सहकार्य करा.
        </p>

        {/* QR Codes */}
        <div className="digital-kar-scanners">

          {/* Gram Nidhi */}
          <div className="digital-kar-item">
            <div className="digital-kar-qr">
              <img
                src={gramnidhiscanner}
                alt="ग्रामनिधी QR Code"
              />
            </div>

            <h3>ग्रामनिधी</h3>
          </div>

          {/* Panipurvatha */}
          <div className="digital-kar-item">
            <div className="digital-kar-qr">
              <img
                src={panipurvtascnner}
                alt="पाणीपुरवठा QR Code"
              />
            </div>

            <h3>पाणीपुरवठा</h3>
          </div>

        </div>

      </div>
    </section>
  );
};

export default DigitalKarVasuli;